module.exports = __webpack_public_path__ + "img/icon-christmas-2.d76dd086.svg";